<template>
  <div class="text-center section calendar-wrapper">
    <v-calendar
      class="custom-calendar max-w-full"
      :masks="masks"
      :attributes="calendarEvents"
      disable-page-swipe
      is-expanded
      locale="sr-Latn-RS"
    >
      <!-- ZA POSTAVLJANJE DEFAULT MESECA STAVI 
     :from-page="{
        month: 4,
        year: 2021
      }" -->
      <!-- @update:from-page="changeMonth" -->
      <template slot="day-content" slot-scope="slotScope">
        <div class="cell-wrapper">
          <span
            class="day-label"
            :class="{
              'highlight-day':
                slotScope.day.day == day &&
                slotScope.day.month == month + 1 &&
                slotScope.day.year == year
            }"
          >
            {{ slotScope.day.day }}
          </span>
          <div class="cell-name-wrapper">
            <div
              class="reminder-cell"
              v-for="attr in slotScope.attributes"
              :key="attr.key"
            >
              <div
                class="cell"
                v-if="attr.customData && attr.customData.title"
                @click="openReminderDetails(attr.customData)"
              >
                <span class="title">{{ attr.customData.title }}</span>
                <span>{{ attr.customData.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </v-calendar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('table', ['calendarEvents'])
  },
  data() {
    return {
      day: new Date().getDate(),
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      masks: {
        weekdays: 'WWW'
      }
    };
  },
  created() {
    this.calendarEvents.push({
      key: 'today',
      dates: new Date()
    });
  },
  methods: {
    // changeMonth(data) {
    //   console.log('promena', data);
    // },
    openReminderDetails(data) {
      this.$router.push({
        name: 'communityReminderDetails',
        params: {
          id: data.communityId,
          reminderId: data.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.highlight-day {
  background: var(--primary-color);
  color: white !important;
  width: fit-content;
  padding: 4px;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  text-align: center;
}
.calendar-wrapper {
  padding-top: 54px;
}
.cell-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: 10;
  overflow: hidden;
  .day-label {
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgba(17, 24, 39, var(--tw-text-opacity));
    cursor: default;
  }
  .cell-name-wrapper {
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: auto;
    .reminder-cell {
      cursor: default;
      .cell {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        background: var(--primary-color);
        padding: 0.25rem;
        font-size: 0.8rem;
        line-height: 1rem;
        line-height: 1.25;
        border-radius: 0.125rem;
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
        color: white;
        .title {
          font-weight: 800;
        }
      }
    }
  }
}
.max-w-full {
  max-width: 100%;
}
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
/deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
}
</style>
